<div mat-dialog-content>
  <div class="row">
    <div class="col-6">
      <h2>Conditions d'utilisation</h2>
      <p>
        Veuillez lire l'intégralité du présent accord. En créant votre compte
        sur la plateforme d’évaluation de <strong>KortoJura inc.</strong>, vous
        confirmez votre acceptation de ces conditions. Il s'agit d'un contrat
        entre vous et <strong>KortoJura inc.</strong> relatif à votre accès à
        ses produits et services ainsi qu’à leur utilisation. Si vous n'acceptez
        pas ces conditions, vous ne devez pas finaliser la création de votre
        compte sur cette plateforme.
      </p>
      <p>
        Pour accepter ces conditions et pour créer un compte, vous devez être un
        adulte ayant atteint l'âge légal de la majorité selon la province
        canadienne où votre compte a été créé. Vous êtes responsable, sur le
        plan juridique et financier, de toutes les activités sur votre compte, y
        compris les activités d'enfants et de quiconque a accès à votre compte.
      </p>
      <h5>1. Accès aux services</h5>
      <p>
        <strong>KortoJura</strong> offre un service personnel, non-transférable,
        non-exclusif, et limité par un contrat d’utilisation et d’accès à la
        plateforme de service d’évaluation, tel qu’indiqué par ces conditions et
        cet accord
      </p>
      Outre ce qui est permis par cet accord ou par
      <strong>KortoJura</strong> par l’entremise d’une communication écrite
      officielle, ce contrat ne permet à quiconque de :
      <ul>
        <li>
          vendre, transférer, assigner, distribuer, ou exploiter d’une façon
          commerciale quelconque les services ou les contenus de la plateforme ;
        </li>
        <li>
          modifier ou copier les services ou les contenus de la plateforme ;
        </li>
        <li>
          accéder aux services et contenus de la plateforme dans le but de créer
          des services ou des contenus similaires ou compétitifs à ceux de
          <strong>KortoJura</strong>.
        </li>
      </ul>
      <br />
      <h5>2. Compte et sécurité</h5>
      <p>
        Pour utiliser les services offerts sur la plateforme d’évaluation, vous
        serez amené à vous créer un compte utilisateur, à nous fournir un nom
        d’utilisateur (adresse courriel), un mot de passe et certaines autres
        informations vous concernant, tel qu’indiqué dans la Politique de
        confidentialité.
      </p>
      <p>
        Vous êtes seul responsable des informations associées à votre compte et
        de tout ce qui s’y déroule. Vous devez maintenir la sécurité de votre
        compte et informer promptement <strong>KortoJura</strong> si vous
        découvrez ou soupçonnez qu’une personne a accédé à votre compte sans
        votre permission. Nous vous recommandons de créer un mot de passe
        robuste qui sera uniquement utilisé pour accéder à la plateforme
        d’évaluation.
      </p>
      <p>
        Il est formellement interdit de vendre ou transférer votre compte sans
        autorisation écrite officielle par <strong>KortoJura</strong>.
      </p>
      <p>
        <strong>KortoJura</strong> se réserve le droit de modifier, suspendre ou
        interrompre ses services (en totalité ou en partie) à tout moment, avec
        ou sans préavis. Toute version future, mise à jour ou autre ajout à la
        fonctionnalité des services de la plateforme d’évaluation sera soumis
        aux présentes conditions, qui peuvent être mises à jour sans préavis. La
        dernière date de modification de ce document est disponible en tout
        temps.
      </p>
      <p>
        Ainsi, vous convenez que <strong>KortoJura</strong> a ne sera pas tenu
        responsable de toute modification, suspension ou interruption de ses
        services ou de toute partie de ceux-ci.
      </p>
    </div>
    <div class="col-6">
      <h2>Terms and Conditions</h2>
      <p>
        Please read this agreement in its entirety. By creating your account on
        <strong>KortoJura Inc.’s</strong> evaluation platform, you confirm your
        acceptance of these conditions. This is a contract between you and
        <strong>KortoJura Inc.</strong>relating to your access to and use of its
        products and services. If you do not accept these conditions, you should
        not finalize the creation of your account on this platform.
      </p>
      <p>
        To accept these terms and conditions and to create an account, you must
        be an adult of legal age of majority in the Canadian province in which
        your account was created. You are legally and financially responsible
        for all activities on your account, including the activities of children
        and anyone else who has access to your account.
      </p>
      <br />

      <h5>1. Access to Services</h5>
      <p>
        <strong>KortoJura</strong> offers a personal, non-transferable,
        non-exclusive service, and limited by a contract of use and access to
        the evaluation service platform, as indicated by these terms and
        conditions and this agreement.
      </p>
      In addition to what is permitted by this agreement or by
      <strong>KortoJura</strong> through formal written communication, this
      contract does not allow anyone to:
      <ul>
        <li>
          sell, transfer, assign, assign, distribute, or otherwise commercially
          exploit the services or content of the platform;
        </li>
        <li>modify or copy the services or contents of the platform;</li>
        <li>
          access the services and content of the platform in order to create
          services or content similar or competitive to those of
          <strong>KortoJura.</strong>
        </li>
      </ul>
      <br />
      <h5>2. Account and Security</h5>
      <p>
        To use the services offered on the evaluation platform, you will need to
        create a user account, provide us with a username (email address),
        password and certain other information about yourself, as indicated in
        the Privacy Policy.
      </p>
      <p>
        You are solely responsible for the information associated with your
        account and everything that happens on it. You must maintain the
        security of your account and promptly notify
        <strong>KortoJura</strong> if you discover or suspect that someone has
        accessed your account without your permission. We recommend that you
        create a strong password that will only be used to access the evaluation
        platform.
      </p>
      <p>
        It is strictly forbidden to sell or transfer your account without
        official written authorization by <strong>KortoJura</strong>.
      </p>
      <p>
        <strong>KortoJura</strong> reserves the right to modify, suspend or
        interrupt its services (in whole or in part) at any time, with or
        without notice. Any future version, update or other addition to the
        functionality of the evaluation platform services will be subject to
        these terms and conditions, which may be updated without notice. The
        latest modification date of this document is available at any time.
      </p>
      <p>
        Accordingly, you agree that <strong>KortoJura</strong> shall not be
        liable for any modification, suspension or interruption of its services
        or any part thereof.
      </p>
    </div>
  </div>
</div>
<div mat-dialog-actions>
  <button class="btn btn-secondary" mat-dialog-close>{{ 'Global.Close' | translate }}</button>
</div>
